// State-based real-property security instrument selection (mirrors backend borrower.py).
export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"],
  ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"],
  ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
  ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
  ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
  ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
  ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
];

const DEED_OF_TRUST = new Set(["AK", "AZ", "CA", "CO", "DC", "ID", "MD", "MS", "MO", "MT", "NE", "NV", "NC", "OR", "TN", "TX", "UT", "VA", "WA", "WV", "WY"]);

export function instrumentForState(state) {
  const st = (state || "").trim().toUpperCase();
  if (!st) return null;
  if (st === "GA") return "Security Deed (Deed to Secure Debt)";
  if (DEED_OF_TRUST.has(st)) return "Deed of Trust";
  return "Mortgage";
}

// Georgia intangible recording tax: $1.50 per $500 of the note, capped at $25,000.
export function gaIntangibleTax(face) {
  const f = Number(face) || 0;
  if (f <= 0) return 0;
  return Math.min(25000, Math.ceil(f / 500) * 1.5);
}

// Recommended note structure: 62-month balloon for GA (intangible-tax exempt), else standard.
export function recommendedNoteStructure(state) {
  return (state || "").trim().toUpperCase() === "GA" ? "balloon_62" : "standard";
}
